import { useTranslate } from 'react-admin';

import { allCountryCodes, countryMap } from '@Common/countries';
import { countryDataByCodeBo } from '@Common/countries/country_data';

export const allCountryCodesChoices = allCountryCodes.map((code) => ({
  id: code,
  name: countryMap[code].name,
}));

export const countryChoices = Object.values(countryDataByCodeBo)
  .sort((a, b) => a.code.localeCompare(b.code))
  .map((country) => ({
    id: country.code,
    name: `${country.code} - ${country.name}`,
  }));

/**
 * Hook that returns localized country choices by adjective
 *
 * @returns Array of choices with localized adjectives
 */
export const useCountryCodeChoicesByAdjective = () => {
  const translate = useTranslate();
  return allCountryCodes.map((key) => {
    const adjective = translate(`common.countries.adjective.${key.toLowerCase()}`, {
      _: countryMap[key].adjective || countryMap[key].name,
    });
    return {
      id: key,
      name: `${key} - ${adjective}`,
    };
  });
};

/**
 * Hook that returns localized country choices by name
 *
 * @returns Array of choices with localized country names
 */
export const useCountryCodeChoicesByName = (): CountryCodeChoices => {
  const translate = useTranslate();
  return allCountryCodes.map((key) => {
    const name = translate(`common.countries.${key.toLowerCase()}`, {
      _: countryMap[key].name,
    });
    return {
      id: key,
      name: `${key} - ${name}`,
    };
  });
};

export interface CountryCodeChoice {
  id: string;
  name: string;
}

export type CountryCodeChoices = CountryCodeChoice[];
